module.exports = __webpack_public_path__ + "static/media/alveoli.a3d47dba.ogg";